var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.4507 4.53168C17.7094 4.78063 17.7172 5.19211 17.4683 5.45075L7.84329 15.4508C7.72076 15.5781 7.55167 15.65 7.37498 15.65C7.19828 15.65 7.02919 15.5781 6.90666 15.4508L2.53166 10.9053C2.28271 10.6467 2.29058 10.2352 2.54922 9.98623C2.80787 9.73728 3.21935 9.74515 3.46829 10.0038L7.37498 14.0627L16.5317 4.54924C16.7806 4.2906 17.1921 4.28274 17.4507 4.53168Z"}));
}

Check.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Check;

Check.default = Check;
